/**
 * CDN image URLs for local preview and Hostinger builds.
 * Format matches Unsplash’s recommended query params (ixlib + auto=format + fit=crop + w).
 * Logo (`/assets/logo.png`) and favicons stay in `public/` by design.
 */

/** Files served from `frontend/public/assets/` via `LOCAL` below. */
const publicAsset = (filename) =>
  `${process.env.PUBLIC_URL || ''}/assets/${filename}`;

/**
 * Local headshots — add these files under `public/assets/` before deploy:
 * - ankit-raj.jpg
 * - bhumika-saha.jpg
 * - rohit-kundan.jpg
 * - mitali-saha.jpg (legacy; counsellor page uses MARKETING.counsellorMitaliSaha)
 */
export const LOCAL = {
  teamAnkitRaj: publicAsset('ankit-raj.jpg'),
  teamBhumikaSaha: publicAsset('bhumika-saha.jpg'),
  teamRohitKundan: publicAsset('rohit-kundan.jpg'),
  counsellorMitaliSaha: publicAsset('mitali-saha.jpg'),
};

/** Same-origin marketing folder (`frontend/public/marketing/`). */
const publicMarketing = (filename) =>
  `${process.env.PUBLIC_URL || ''}/marketing/${filename}`;

export const MARKETING = {
  /** Student reviews — real photos; keep files in repo for deploy. */
  testimonialJyotika: publicMarketing('testimonial-jyotika.png'),
  testimonialSneha: publicMarketing('testimonial-sneha.png'),
  testimonialDhruv: publicMarketing('testimonial-dhruv.png'),
  testimonialAman: publicMarketing('testimonial-aman.png'),
  testimonialPiyush: publicMarketing('testimonial-piyush.png'),
  testimonialAashima: publicMarketing('testimonial-aashima.png'),
  /** Expert counsellors page — real photos in `public/marketing/`. */
  counsellorMitaliSaha: publicMarketing('counsellor-mitali-saha.png'),
  counsellorShreya: publicMarketing('counsellor-shreya.png'),
  /** Filename casing matches file in `public/marketing/` (some hosts are case-sensitive). */
  counsellorRiya: publicMarketing('Counsellor-riya.png'),
  counsellorRohit: publicMarketing('counsellor-rohit.jpg'),
};

const unsplash = (photoPath, w = 1600) =>
  `https://images.unsplash.com/${photoPath}?ixlib=rb-4.0.3&auto=format&fit=crop&w=${w}&q=80`;

export const CDN = {
  /** Schools / partnership strip: institution & program context (distinct from hero/trust/problem) */
  schoolPartnerHero: unsplash('photo-1562774053-701939374585', 1600),
  /** School problem quote card: focused classroom learning (Career DNA in action) */
  problemSchool: unsplash('photo-1509062522246-3755977927d7', 1600),
  /** Student problem strip */
  problemStudent: unsplash('photo-1523240795612-9a054b0db644', 1600),
  /** Counseling section — collaboration / guidance */
  counselingSession: unsplash('photo-1552664730-d307ca884978', 1200),
  /** Team card placeholder until a local asset is added (Anish Choudhary in mock.js) */
  teamAnishChoudhary: unsplash('photo-1519085360753-af0119f7cbe7', 800),
  /** Placeholder headshot — Vikram [0]; Mitali, Shreya, Rohit, Riya use MARKETING. */
  counsellors: [unsplash('photo-1506794778202-cad84cf45f1d', 800)],
};
